import React from "react";

function Info() {
  return (
    <div>
      <section class="text-gray-400 bg-gray-900 body-font">
        <div class="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
          <div class="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
            <h1 class="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
              We always value our <br class="hidden lg:inline-block" />
              Customers
            </h1>
            <p class="mb-8 leading-relaxed">
              Hi, I am
              <span class="text-purple-400 bold font-bold"> Manik Paul </span>
              (owner). You can trust our service and the quality of products we
              deliver. We will appreciate if you can come and visit our store
              for any query.
            </p>
          </div>
          <div class="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
            <img
              class="object-cover object-center rounded"
              alt="hero"
              src="./img/photo.jpg"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default Info;
